/**
 * The PATCH /v1/me bodies for the AI controls (Settings and Get Started). Since TMMAPI-0151 the
 * plan cap is gone: AI on / off is its own switch, and the personal monthly limit stands alone
 * (`aiMonthlyCapMinor`, 0 = no limit). Each sends only what changed; nothing changed sends `{}`.
 */
export interface AiLimitPatchBody {
  aiEnabled?: boolean;
  aiMonthlyCapMinor?: number;
}

export function aiEnabledPatch(aiEnabled: boolean, nextEnabled: boolean): AiLimitPatchBody {
  return aiEnabled === nextEnabled ? {} : { aiEnabled: nextEnabled };
}

/** A stored limit above 0, rounded; `null` = none. */
export function storedLimit(capMinor: number | null): number | null {
  return capMinor != null && Number.isFinite(capMinor) && capMinor > 0
    ? Math.round(capMinor)
    : null;
}

/** `nextCapMinor` null (or not above 0) = no limit, sent as 0 only when a limit is stored. */
export function personalLimitPatch(
  capMinor: number | null,
  nextCapMinor: number | null,
): AiLimitPatchBody {
  const stored = storedLimit(capMinor);
  const next = storedLimit(nextCapMinor);
  if (next === stored) return {};
  return { aiMonthlyCapMinor: next ?? 0 };
}
